import Tidal from '../../pages-dynamic/info/tidal/terms';
import BotMart from '../../pages-dynamic/info/botmart/terms';

export default process.env.WHITE_LABEL_ORG === 'botmart' ? BotMart : Tidal;
